import React, { Component } from 'react';
import { connect } from "react-redux";
import Input from 'Components/Input';
import Select from 'react-select';
import { ReactComponent as Cancel } from 'Icons/cancel.svg';
import {  ReactComponent as Esclamation } from 'Icons/esclamation.svg';
import {  ReactComponent as Calender } from 'Icons/calender.svg';
import {  ReactComponent as Delete } from 'Icons/delete.svg';
import { ReactComponent as PhotoLibrary } from 'Icons/photo-library.svg';
import { ReactComponent as Edit } from 'Icons/editIconT1.svg';
import { SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import Upload from "Components/Upload/index";
import { ReactComponent as UploadIcon } from 'Icons/upload.svg';
import { ReactComponent as ArrowDown } from 'Icons/arrowFill.svg';
import Cx from 'classnames';
import {
    UPLOAD_DOCUMENT,
    SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    GET_PO_DATA_BY_ID,
    GET_PART_DETAILS,
    DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
} from 'Constants/actionConstants';

const partData = {
    part_number: '',
    drawing_revision: '',
    drawing_status: '',
    quantity: 0,
    net_weight: 0,
    po_delivery_date: null,
    proposed_delivery_date: null
};

const rawMaterialsObj = {
    product_description: '',
    product_grade: '',
    required_quantity: '',
    expected_date: null,
    uploaded_doc: '',
    is_approval_required: false,
    remarks: ''
}

const productionStatueObj = {
    process: '',
    start_date: null,
    completion_date: null,
    production_status: '',
    uploaded_doc: '',
    is_approval_required: false,
    remarks: ''
}

class CreatePO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.isEdit ? props.editedData : {
                project_id: '',
                po_number: '',
                order_acknowledge_number: '',
                advance_payment_in_percentage: '',
                // po_value: '',
                email_ids: [],
                proforma_invoice_doc:{},
                partDetails: [
                    {
                        part_number: '',
                        drawing_revision: '',
                        drawing_status: '',
                        quantity: 0,
                        net_weight: 0,
                        po_delivery_date: null,
                        proposed_delivery_date: null,
                        rawMaterials: [{...rawMaterialsObj}]
                    }
                ]
            },
            editId: ''
        }
    }

    validatePODeliveryAndRelatedDates = () => {
        const { data } = this.state;
        let isValid = true;
        let errorMsg = '';
        (data.partDetails || []).forEach((part, idx) => {
            if (!part.po_delivery_date || isNaN(part.po_delivery_date)) {
                isValid = false;
                errorMsg = `Please enter a valid PO Delivery Date for all parts.`;
                return;
            }
            // Validate rawMaterials required_date and expected_date
            (part.rawMaterials || []).forEach((rm, rmIdx) => {
                if (!rm.required_date || isNaN(rm.required_date)) {
                    isValid = false;
                    errorMsg = `Please enter a valid Required Date for all raw materials.`;
                    return;
                }
                if (rm.required_date > part.po_delivery_date) {
                    isValid = false;
                    errorMsg = `Required Date cannot be after PO Delivery Date.`;
                    return;
                }
                if (!part.proposed_delivery_date || isNaN(part.proposed_delivery_date)) {
                    isValid = false;
                    errorMsg = `Please enter a valid Proposed Delivery Date for all parts.`;
                    return;
                }
                if (part.proposed_delivery_date < part.po_delivery_date) {
                    isValid = false;
                    errorMsg = `Proposed Delivery Date cannot be before PO Delivery Date.`;
                    return;
                }
            });
            // Validate productionStatus start_date and completion_date
            (part.productionStatus || []).forEach((ps, psIdx) => {
                if (ps.start_date && !isNaN(ps.start_date) && ps.start_date > part.po_delivery_date) {
                    isValid = false;
                    errorMsg = `Production Start Date cannot be after PO Delivery Date.`;
                    return;
                }
                if (ps.completion_date && !isNaN(ps.completion_date) && ps.completion_date > part.po_delivery_date) {
                    isValid = false;
                    errorMsg = `Production Completion Date cannot be after PO Delivery Date.`;
                    return;
                }
            });
        });
        return { isValid, errorMsg };
    }

    createOrDraftPO = (status, isDraft) => {
        const { data } = this.state;
        const dateValidation = this.validatePODeliveryAndRelatedDates();
        if (!dateValidation.isValid) {
            this.props.throwError(dateValidation.errorMsg);
            this.setState({ mandatoryError: true });
            return;
        }
        if((!this.validateFields() || !this.validateRawMaterials())) {
            this.props.throwError('Please Enter all the mandatory fields');
            this.setState({
                mandatoryError: true
            });
            return;
        }
        let poData = {
            ...data,
            status,
            is_draft: isDraft
        }
        this.props.onCreate(poData, this.onClearPOData);
    }

    validateRawMaterials = () => {
        const { data } = this.state;
        let rawFlag = true;
        (data.partDetails || []).every(el => {
            const validateFlag = (el.rawMaterials || []).some(rawObj => {
                return (rawObj.product_description && rawObj.product_grade && rawObj.required_quantity && rawObj.expected_date)
            });
            if(!validateFlag) {
                rawFlag = false;
                return false;
            }
        });
        return rawFlag;
    }

    onClearPOData = () => {
        this.setState({
            data: {}
        });
    }

    onChange = (e) => {
        const { data } = this.state;
        const { name, value } = e.target;
        data[name] = value;
        this.setState({
            data
        });
    }

    onSelect = (option, name) => {
        const { data } = this.state;
        data[name] = option.value;
        this.setState({
            data
        });
    }

    addEmail = () => {
        const { data, email_id } = this.state;
        if(!this.validateEmail(email_id)) {
            this.props.throwError('Please Enter the Valid Email');
            return;
        } else {
            data['email_ids'].push(email_id);
            this.setState({
                data,
                email_id: ''
            });
        }
    }

    onDeleteEmail = (index) => {
        const { data } = this.state;
        data.email_ids.splice(index, 1);
        this.setState({
            data
        });
    }

    addPartDetails = () => {
        const { data } = this.state;
        data.partDetails.push({
            ...partData,
            rawMaterials: [{...rawMaterialsObj}]
        });
        this.setState(data);
    }

    onDeletPartData = (index) => {
        const { data } = this.state;
        data.partDetails.splice(index, 1);
        this.setState(data);
    }

    onChangePartData = (e, index) => {
        const { data } = this.state;
        const { name, value } = e.target;
        data.partDetails[index][name] = (['net_weight', 'quantity'].includes(name) && value) ? Number(value) : value;
        this.setState({
            data
        });
    }

    onChangeDate = (date, name, partIndex) => {
        const { data } = this.state;
        if(date) {
            if(name == 'proposed_delivery_date') {
                const poDelivery =  data.partDetails[partIndex]['po_delivery_date'];
                const selectedDate = date.valueOf();
                if(poDelivery && selectedDate >= poDelivery.valueOf()) {
                    data.partDetails[partIndex][name] = selectedDate;
                } else if(poDelivery && selectedDate < poDelivery.valueOf()) {
                    this.props.throwError('Proposed delivery date should be on or after the PO delivery date.');
                }
                else if(!poDelivery) {
                    this.props.throwError('Please Select the PO Delivery Date');
                }
            } else {
                data.partDetails[partIndex][name] = date.valueOf();
            }
            this.setState({
                data
            });
        }
    }

    onSelectPartData = (option, name, partIndex) => {
        const { data } = this.state;
        data.partDetails[partIndex][name] = option.value;
        this.setState({
            data
        });
    }

    validateEmail = (mail) => {
        let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(mail)
    }

    validateFields = () => {
        const { data } = this.state;
        let isFlag = true;
        if(!(data.po_number 
            && data.project_id 
            && (data.advance_payment_in_percentage !== '') 
            && data.order_acknowledge_number) || (data.email_ids || []).length == 0 || (data.partDetails || []).find(el => !(el.part_number 
            && el.drawing_number 
            && el.drawing_revision 
            && el.drawing_status 
            && el.quantity 
            && el.net_weight 
            && el.po_delivery_date 
            && el.proposed_delivery_date))){
            isFlag = false;
        }
        return isFlag
    }

    onAddRM = (index) => {
        const { data } = this.state;
        data.partDetails[index].rawMaterials.push({
            ...rawMaterialsObj
        });
        this.setState({
            data
        });
    }

    onDeleteRawMaterials = (index, rmIndex) => {
        const { data } = this.state;
        data.partDetails[index].rawMaterials.splice(rmIndex, 1);
        this.setState({
            data
        });
    }

    addNextProcess = (index) => {
        const { data } = this.state;
        if(!data.partDetails[index].productionStatus) {
            data.partDetails[index].productionStatus = [];
        }
        data.partDetails[index].productionStatus.push({
            ...productionStatueObj
        });
        this.setState({
            data
        });
    }

    onDeleteProductionStatus = (index, rmIndex) => {
        const { data } = this.state;
        data.partDetails[index].productionStatus.splice(rmIndex, 1);
        this.setState({
            data
        });
    }

    onSelectProcessStatus = (option, partIndex, index, name, id) => {
        const { data } = this.state;
        data.partDetails[partIndex].productionStatus[index][name] = option.value; 
        data.partDetails[partIndex].productionStatus[index][id] = option.id;
        this.setState({
            data
        });
    }

    onChangeProductionStatusDates = (date, name, index, partIndex) => {
        const { data } = this.state;
        if(date) {
            const poDeliveryDate = data.partDetails[partIndex]['po_delivery_date'];
            if (poDeliveryDate && date.valueOf() > poDeliveryDate) {
                this.props.throwError('Production start and completion dates should be on or before the PO delivery date.');
                return;
            }
            data.partDetails[partIndex].productionStatus[index][name] = date.valueOf();
            this.setState({
                data
            });
        }
    }

    onChangeProcessStatus = (e, index, partIndex) => {
        const { data } = this.state;
        const { checked } = e.target;
        data.partDetails[partIndex].productionStatus[index]['is_approval_required'] = checked;
        this.setState({
            data
        });
    }

    onChangeProcessInput = (e, index, partIndex) => {
        const { data } = this.state;
        const { name, value } = e.target;
        data.partDetails[partIndex].productionStatus[index][name] = value;
        this.setState({
            data
        });
    }

    onUploadDocument = (file, index, type, partIndex) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            noSaveUpload: true,
            onSuccess: (result) => { 
                if(type === 1) {
                    const { data } = this.state;
                    data.partDetails[partIndex].rawMaterials[index].uploaded_doc = result;
                    this.setState({
                        data
                    });
                } else {
                    const { data } = this.state;
                    data.partDetails[partIndex].productionStatus[index].uploaded_doc = result;
                    this.setState({
                        data
                    });
                }
            }
        })
    }

    onChangeRawMaterial = (e, index, partIndex) => {
        const { data } = this.state;
        const { name, value } = e.target;
        data.partDetails[partIndex].rawMaterials[index][name] = ['required_quantity'].includes(name) && value ? Number(value) : value;
        this.setState({
            data
        });
    }

    onChangeRawMaterialsDate = (date, name, index, partIndex) => {
        const { data } = this.state;
        if(date) {
            const poDeliveryDate = data.partDetails[partIndex]['po_delivery_date'];
            if (name === 'required_date') {
                if (poDeliveryDate && date.valueOf() > poDeliveryDate) {
                    this.props.throwError('Required Date should be on or before the PO delivery date.');
                    return;
                }
            }
            data.partDetails[partIndex].rawMaterials[index][name] = date.valueOf();
            this.setState({
                data
            });
        }
    }

    onSelectRawMaterial = (option, index, name, id, partIndex) => {
        const { data } = this.state;
        data.partDetails[partIndex].rawMaterials[index][name] = option.value;
        data.partDetails[partIndex].rawMaterials[index][id] = option.id;
        this.setState({
            data
        });
    }

    onChangeStatusRawMaterial = (e, index, partIndex) => {
        const { data } = this.state;
        const { checked } = e.target;
        data.partDetails[partIndex].rawMaterials[index]['is_approval_required'] = checked;
        this.setState({
            data
        });
    }

    onClickEdit = (id) => {
        this.setState({
            editId: id
        });
    }

    onSaveRawMaterials = (partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 1,
                raw_material: (partData.rawMaterials || []).filter(el => !el.raw_material_id),
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                this.getPOData();
            }
        })
    }

    onUpdateRawMaterial = (rawMaterial, partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 1,
                raw_material: rawMaterial,
                raw_material_id: rawMaterial.raw_material_id,
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                this.setState({
                    editId: ''
                });
                this.getPOData();
            }
        });
    }

    handleDeleteRawMaterial = (rawMaterial) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 1,
                raw_material_id: rawMaterial.raw_material_id,
            },
            onSuccess: () => {
                this.getPOData();
            }
        });
    }

    onSaveProductionStatus = (data, partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 2,
                production_status: data ? [{...data }] : (partData.productionStatus || []).filter(el => !el.production_status_id),
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                this.getPOData();
            }
        })
    }

    onUpdateProductionStatus = (data, partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 2,
                production_status: data,
                production_status_id: data.production_status_id,
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                this.setState({
                    editId: ''
                });
                this.getPOData();
            }
        });
    }

    handleDeleteProductionStatus = (data) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 2,
                production_status_id: data.production_status_id,
            },
            onSuccess: () => {
                this.getPOData();
            }
        });
    }

    getPOData = () => {
        const { dispatch } = this.props;
        const { data } = this.state;
        dispatch({
            // type: GET_PO_DATA_BY_ID,
            type: GET_PART_DETAILS,
            params: {
                poId: data.po_id,
                poPartId: ((data.partDetails && data.partDetails[0] || {}).po_part_id) || (data || {}).po_part_id
            },
            onSuccess: (result) => {
                this.setState({
                    data: result || {},
                });
            }
        })
    }

    onUploadProformaInvoice = (file) => {
        const { dispatch } = this.props;
        if (!file) return;

        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            noSaveUpload: true,
            onSuccess: (result) => {

                const uploadedFile = {
                    name: result.name || file.name,
                    url: result.url,
                };

                this.setState((prevState) => ({
                    data: {
                        ...prevState.data,
                        proforma_invoice_doc: uploadedFile,
                    },
                }));
            },
        });
    };

    render() {
        const { data, email_id, editId, mandatoryError } = this.state;
        const { advancePayment, drawingRevision, drawingStatus, drawingNumber, productType, productGrade, productionProcess, productionStatus } = this.props.poDropdownLists;
        const { isEdit } = this.props;

        const customStyles = {
            menu: (provided) => ({
              ...provided,
              position: 'absolute',
              zIndex: 9999, // Set a higher z-index value
            }),
          };

        return (
            <div className="createNewPO">
                <div className={'fs-12'} Style={{'color': '#30343C'}}><span className={'curP'} style={{'color': '#597EF7'}} onClick={this.props.onClickMyOrders}>{'My Orders'}</span><span className="ml-10 mr-10">{'>'}</span> Create New Order </div>
                <div className="orderHeader mt-10 mb-10">
                    {`${(isEdit && data.status != 1) ? 'Edit' : 'Create'} New Order`}
                </div>
                <div className={'newOrder mr-10 mb-10'} style={{'background': '#F4F6FF'}}>
                    <div className="subHeader">Project Details</div>
                    <div className="mt-20 flex">
                        <div className={'wt-300 mr-10'}>
                            <div className="pLabel">Project ID<sup>*</sup></div>
                            <Input 
                                placeholder={'Enter Projec ID'}
                                className={Cx('pInput', {
                                    'error': (!data.project_id && mandatoryError)
                                })}
                                // type="number"
                                name="project_id"
                                value={data.project_id}
                                onChange={this.onChange}
                                readOnly={isEdit && data.status != 1}
                            />
                        </div>
                        <div className={'wt-300 mr-10'}>
                            <div className="pLabel">PO Number<sup>*</sup></div>
                            <Input 
                                className={Cx('pInput', {
                                    'error': (!data.po_number && mandatoryError)
                                })}
                                placeholder={'Enter PO Number'}
                                // type="number"
                                name="po_number"
                                value={data.po_number}
                                onChange={this.onChange}
                            />
                        </div>
                        {/* <div className={'wt-300 mr-10'}>
                            <div className="pLabel">PO Value<sup>*</sup></div>
                            <Input 
                                className={Cx('pInput', {
                                    'error': (!data.po_value && mandatoryError)
                                })}
                                placeholder={'Enter PO Value'}
                                type="number"
                                name="po_value"
                                value={data.po_value}
                                onChange={this.onChange}
                            />
                        </div> */}
                        <div className={'wt-300 mr-10'}>
                            <div className="pLabel">Order Acknowledge  Number<sup>*</sup></div>
                            <Input 
                                className={Cx('pInput', {
                                    'error': (!data.order_acknowledge_number && mandatoryError)
                                })}
                                placeholder={'Enter Acknowledge Number'}
                                // type="number"
                                name="order_acknowledge_number"
                                value={data.order_acknowledge_number}
                                onChange={this.onChange}
                            />
                        </div>
                        <div className={'wt-300'}>
                            <div className="pLabel">Advance Payment in %</div>
                            <div className={Cx("select fs-14", {
                                'borderError': ((data.advance_payment_in_percentage === '') && mandatoryError)
                            })}>
                                <Select 
                                    placeholder={'Select Advance Payment'}
                                    options={advancePayment}
                                    value={(data.advance_payment_in_percentage !== '') && advancePayment.find(el => el.value == data.advance_payment_in_percentage)}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                    onChange={(option) => this.onSelect(option, 'advance_payment_in_percentage')}
                                />
                            </div>
                        </div>
                        <div className={'wt-300 ml-20'}>
                            <div className="pLabel">Upload Proforma Invoice</div>
                            <div className={"ml-50"}> 
                            <Upload onChange={(file) => this.onUploadProformaInvoice(file)}>
                                <UploadIcon className={'wt-25 ht-25 curP'} />
                            </Upload>
                            </div>
                            {data.proforma_invoice_doc?.name && (
                                <div className={'uploaded-data fs-14'}>
                                    <a
                                        href={data.proforma_invoice_doc.url}
                                        download
                                    >
                                        <PhotoLibrary className="mr-10 wt-15 ht-15" />
                                        {data.proforma_invoice_doc.name}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={'newOrder mr-10 mb-10'}>
                    <div className="subHeader">Email Details</div>
                    <div className="mt-20 flex">
                        <div className={'mr-10'}>
                            <div className="pLabel">Email ID<sup>*</sup></div>
                            <div className="flex">
                                <Input 
                                    type='email'
                                    className={Cx('pInput wt-250 mr-10', {
                                        'error': ((data.email_ids || []).length == 0 && mandatoryError)
                                    })}
                                    value={email_id}
                                    name={'email_id'}
                                    onChange={(e) => {
                                        this.setState({
                                            "email_id": e.target.value
                                        });
                                    }}
                                />
                                <button className={'addEmail curP'} onClick={this.addEmail}>Add</button>
                                {(data.email_ids || []).map((email, eIndex) => 
                                (
                                <>
                                    {email && <div className="ml-10 pv-5 ht-36 emailList br-5 flex">
                                        <div className="ph-10">{email}</div>
                                        <div className="emailCancel ph-10" onClick={() =>this.onDeleteEmail(eIndex)}><Cancel className='wt-12 ht-12 mt-5' path={'#30343C'}/></div>
                                    </div>}
                                </>))}
                            </div>
                            {email_id && !this.validateEmail(email_id) && <div className="fs-12 mt-5 flex flex-middle">
                                <Esclamation className='wt-15 ht-15 mr-5'/> <div>{'Invalid Email Address'}</div>
                            </div>}
                        </div>
                        
                    </div>
                </div>
                {(data.partDetails || []).map((partData, partIndex) => {
                return(
                    <div className={'newOrder mr-10 mb-10'}>
                        <div className={'flex flex-between'}>
                            <div className="subHeader">Part and RM Details</div>
                            {data.partDetails.length > 1 && <div className={'pv-5 pl-5 pr-5 loi-cancelled-color border-red  br-5 fs-12 fSemibold wt-80 flex flex-middle fRight curP'} onClick={() => this.onDeletPartData(partIndex)}><Delete className='mr-10 wt-15 ht-15'/> Remove</div>}
                        </div>
                        <div className="mt-20 flex">
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Part Number<sup>*</sup></div>
                                <Input 
                                    className={Cx('pInput', {
                                        'error': (!partData.part_number && mandatoryError)
                                    })}
                                    placeholder={'Enter Part Number'}
                                    value={partData.part_number}
                                    name={'part_number'}
                                    onChange={(e) => this.onChangePartData(e, partIndex)}
                                />
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Drawing Number<sup>*</sup></div>
                                {/* <Select 
                                    placeholder={'Select...'}
                                    className={'fs-14'}
                                    options={drawingNumber || []}
                                    value={partData.drawing_number && (drawingNumber || []).find(el => el.value == partData.drawing_number)}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                    onChange={(option) => this.onSelectPartData(option, 'drawing_number', partIndex)}
                                /> */}
                                <Input 
                                    type={'number'}
                                    className={Cx('pInput', {
                                        'error': (!partData.drawing_number && mandatoryError)
                                    })}
                                    placeholder={'Enter Drawing Number'}
                                    value={partData.drawing_number}
                                    name={'drawing_number'}
                                    onChange={(e) => this.onChangePartData(e, partIndex)}
                                />
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Drawing Revision<sup>*</sup></div>
                                <Select 
                                    placeholder={'Select..'}
                                    className={Cx('fs-14', {
                                        'borderError': (!partData.drawing_revision && mandatoryError)
                                    })}
                                    options={drawingRevision}
                                    value={partData.drawing_revision && drawingRevision.find(el => el.value == partData.drawing_revision)}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                    onChange={(option) => this.onSelectPartData(option, 'drawing_revision', partIndex)}
                                />
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Drawing Status<sup>*</sup></div>
                                <Select     
                                    placeholder={'Select...'}
                                    className={Cx('fs-14', {
                                        'borderError': (!partData.drawing_status && mandatoryError)
                                    })}
                                    options={drawingStatus}
                                    value={partData.drawing_status && drawingStatus.find(el => el.value == partData.drawing_status)}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                    onChange={(option) => this.onSelectPartData(option, 'drawing_status', partIndex)}
                                />
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Drawing Approved Date<sup>*</sup></div>
                                <div className={Cx("", {
                                            'borderError': (!partData.drawing_approved_date && mandatoryError)
                                        })} >
                                    <SingleDatePicker 
                                        className={"pInput"} 
                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                        inputIconPosition={'after'}
                                        displayFormat={"DD MMM YYYY"}
                                        isOutsideRange={() => false}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"dd/mm/yyyy"}
                                        numberOfMonths={1}
                                        date={partData.drawing_approved_date ? Moment(partData.drawing_approved_date) : ''} 
                                        onDateChange={(date) => this.onChangeDate(date, 'drawing_approved_date', partIndex)}
                                        focused={this.state[`focusedDrawingApprovedDate${partIndex}`]}
                                        onFocusChange={({ focused }) => this.setState({ [`focusedDrawingApprovedDate${partIndex}`]: focused })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mt-10 flex">
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Quantity<sup>*</sup></div>
                                <Input 
                                    className={Cx('pInput', {
                                        'error': (!partData.quantity && mandatoryError)
                                    })} 
                                    placeholder="Enter Quantity"
                                    type="number"
                                    name="quantity"
                                    value={partData.quantity}
                                    onChange={(e) => this.onChangePartData(e, partIndex)}
                                />
                            </div> 
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">RM Net Weight in Kgs<sup>*</sup></div>
                                <Input 
                                    className={Cx('pInput', {
                                        'borderError': (!partData.net_weight && mandatoryError)
                                    })}
                                    placeholder="Enter Net Weight in Kgs"
                                    type="number"
                                    name="net_weight"
                                    value={partData.net_weight}
                                    onChange={(e) => this.onChangePartData(e, partIndex)}
                                />
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">PO Delivery Date<sup>*</sup></div>
                                <div className={Cx("", {
                                        'borderError': (!partData.po_delivery_date && mandatoryError)
                                    })} >
                                    <SingleDatePicker 
                                        className="pInput" 
                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                        inputIconPosition={'after'}
                                        displayFormat={"DD MMM YYYY"}
                                        isOutsideRange={() => false}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"dd/mm/yyyy"}
                                        numberOfMonths={1}
                                        date={partData.po_delivery_date ? Moment(partData.po_delivery_date) : ''} 
                                        onDateChange={(date) => this.onChangeDate(date, 'po_delivery_date', partIndex)}
                                        focused={this.state[`focusedPODeliverDate${partIndex}`]}
                                        onFocusChange={({ focused }) => this.setState({ [`focusedPODeliverDate${partIndex}`]: focused })}
                                />
                                </div>
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Proposed Delivery Date<sup>*</sup></div>
                                <div className={Cx("", {
                                        'borderError': (!partData.proposed_delivery_date && mandatoryError)
                                    })} >
                                    <SingleDatePicker 
                                        className="pInput" 
                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                        inputIconPosition={'after'}
                                        displayFormat={"DD MMM YYYY"}
                                        isOutsideRange={(day) => {
                                            if (partData.po_delivery_date) {
                                                return day.isBefore(Moment(partData.po_delivery_date), 'day');
                                            }
                                            return true;
                                        }}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"dd/mm/yyyy"}
                                        numberOfMonths={1}
                                        date={partData.proposed_delivery_date ? Moment(partData.proposed_delivery_date) : ''} 
                                        onDateChange={(date) => this.onChangeDate(date, 'proposed_delivery_date', partIndex)}
                                        focused={this.state[`focusedProposedDeliverDate${partIndex}`]}
                                        onFocusChange={({ focused }) => this.setState({ [`focusedProposedDeliverDate${partIndex}`]: focused })}
                                    />
                                </div>
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Remarks</div>
                                <Input 
                                    className={'pInput'} 
                                    placeholder="Enter Remarks"
                                    name="remarks"
                                    value={partData.remarks}
                                    onChange={(e) => this.onChangePartData(e, partIndex)}
                                />
                            </div> 
                        </div>
                        <div className={'rmTable br-5'}>
                            <div className={this.state.isPadding ? 'pb-500 table-wrapper' : 'table-wrapper'}>
                                <table cellSpacing={0} width={'100%'}>
                                        <tr>
                                            <th className={'wt-200'}>RM Grade<sup>*</sup></th>
                                            <th>RM Used For<sup>*</sup></th>
                                            <th className={'wt-100'}>Required Quantity<sup>*</sup></th>
                                            <th>Required Date<sup>*</sup></th>
                                            <th>Expected Date<sup>*</sup></th>
                                            <th>Approval Required</th>
                                            <th>Upload Document</th>
                                            <th>Remarks</th>
                                            <th className={'pSticky'}>Actions</th>
                                        </tr>
                                        {(partData.rawMaterials || []).map((material, mIndex) => {
                                            const isUnEditable = (material.raw_material_id && (editId !=  material.raw_material_id))
                                        return(<tr>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <Input 
                                                    className={Cx('fs-14', {
                                                        'borderError': (!material.product_grade && mandatoryError)
                                                    })}
                                                    placeholder={'Enter Product Grade'}
                                                    value={material.product_grade}
                                                    name={'product_grade'}
                                                    onChange={(e) => this.onChangeRawMaterial(e, mIndex, partIndex)}
                                                />
                                            {/* <div className={Cx("", {
                                                'borderError': (!material.product_grade && mandatoryError)
                                            })} >
                                                <Select 
                                                    styles={customStyles}
                                                    menuPortalTarget={document.body}
                                                    options={productGrade || []}
                                                    getOptionLabel={(option) => option.value}
                                                    getOptionValue={(option) => option.id}
                                                    value={material.product_grade && (productGrade || []).find(el => el.value === material.product_grade)}
                                                    onChange={(option) => this.onSelectRawMaterial(option, mIndex, 'product_grade', 'product_grade_id', partIndex)}
                                                />
                                            </div> */}
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <Input 
                                                    className={Cx('fs-14', {
                                                        'borderError': (!material.product_description && mandatoryError)
                                                    })}
                                                    placeholder={'Enter Product Description'}
                                                    value={material.product_description}
                                                    name={'product_description'}
                                                    onChange={(e) => this.onChangeRawMaterial(e, mIndex, partIndex)}
                                                />
                                            </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <Input 
                                                    className={Cx('fs-14', {
                                                        'borderError': (!material.required_quantity && mandatoryError)
                                                    })}
                                                    type={'number'}
                                                    placeholder={'Enter Required Qunatity'}
                                                    value={material.required_quantity}
                                                    name={'required_quantity'}
                                                    onChange={(e) => this.onChangeRawMaterial(e, mIndex, partIndex)}
                                                />
                                            </td>
                                            <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <div className={Cx("", {
                                                    'borderError': (!material.required_date && mandatoryError)
                                                })} >
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        id={`${partIndex}_mIndex`}
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={(day) => {
                                                            if (partData.po_delivery_date) {
                                                                return day.isAfter(Moment(partData.po_delivery_date), 'day');
                                                            }
                                                            return true;
                                                        }}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={1}
                                                        date={material.required_date ? Moment(material.required_date) : ''} 
                                                        onDateChange={(date) => this.onChangeRawMaterialsDate(date, 'required_date', mIndex, partIndex)}
                                                        focused={this.state[`focusedRequiredDate_${partIndex}_${mIndex}`]}
                                                        onFocusChange={(e) => {
                                                            this.setState({ [`focusedRequiredDate_${partIndex}_${mIndex}`]: e.focused, isPadding: e.focused })
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <div className={Cx("", {
                                                    'borderError': (!material.expected_date && mandatoryError)
                                                })} >
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={() => false}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={1}
                                                        date={material.expected_date ? Moment(material.expected_date) : ''} 
                                                        onDateChange={(date) => this.onChangeRawMaterialsDate(date, 'expected_date', mIndex, partIndex)}
                                                        focused={this.state[`focusedExpectedDate_${partIndex}_${mIndex}`]}
                                                        onFocusChange={({ focused }) => this.setState({ [`focusedExpectedDate_${partIndex}_${mIndex}`]: focused , isPadding: focused})}
                                                        // withPortal
                                                    />
                                                </div>
                                            </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}> 
                                            <div className="switch" >
                                                <input type="checkbox"  checked={material.is_approval_required} id={`rawMaterial_${partIndex}_${mIndex}`} onChange={(e) => this.onChangeStatusRawMaterial(e, mIndex, partIndex)}/>
                                                <label htmlFor={`rawMaterial_${partIndex}_${mIndex}`}></label>
                                            </div>
                                        </td>
                                        <td className={'tdWidth'}>
                                            <Upload onChange={(file) => this.onUploadDocument(file, mIndex, 1, partIndex)}  className={isUnEditable ? 'disabled' : ''}>
                                                <UploadIcon className={isUnEditable ? 'disabled wt-25 ht-25 ' : 'wt-25 ht-25 curP'}/>
                                            </Upload>
                                            {(material.uploaded_doc || {}).name && <div className={'uploaded-data fs-14'}>
                                                        <a href={(material.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15" />{(material.uploaded_doc || {}).name}</a>
                                                </div>}
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <Input 
                                                className={'fs-14'}
                                                placeholder={'Enter Remarks'}
                                                value={material.remarks}
                                                name={'remarks'}
                                                onChange={(e) => this.onChangeRawMaterial(e, mIndex, partIndex)}
                                            />
                                        </td>
                                        <td>
                                            {material.raw_material_id && !material.is_accept && <div className={'flex flex-between flex-middle'}>
                                                <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => this.onUpdateRawMaterial(material, partData)}>Update</div>
                                                <Edit className={'wt-20 ht-20 curP'} fill={'#627fe9'} onClick={() => this.onClickEdit(material.raw_material_id)}/>
                                                <Delete className='wt-15 ht-15 curP' onClick={() => this.handleDeleteRawMaterial(material)} />
                                            </div>}
                                            {(!material.raw_material_id && (partData.rawMaterials || []).length > 1) && <Delete className='wt-15 ht-15 curP' onClick={() => this.onDeleteRawMaterials(partIndex, mIndex)}/>}
                                            {
                                                material.approverMessage && <div className={material.is_accept == 1 ? 'success-color fs-14' : 'error-color fs-14'}>{material.approverMessage}</div>
                                            }
                                            {material.rejected_remarks &&
                                                <div className={'mt-5'}>{material.rejected_remarks}</div>
                                            }
                                        </td>
                                        </tr>)})}
                                </table>
                            </div>
                            {<div className={'flex flex-middle flex-between mt-10 mb-10 pv-5 ph-10'}>
                                <button className="divButton mr-10 curP" onClick={() => this.onAddRM(partIndex)}>+ Add RM Requirement</button>
                                {(partData && partData.po_part_id && (partData.rawMaterials || []).some(el => !el.raw_material_id)) && <button className="divButton bgPrimary curP" onClick={() => this.onSaveRawMaterials(partData)}>Submit</button>}
                            </div>}
                        </div>
                        <div className={'rmTable br-5'}>
                            <div className={'pv-10 ph-20 productionHeader'}>
                                <div className={'flex flex-between flex-middle'}>
                                    <div>Production Status</div>
                                    <ArrowDown  className='curP'/>
                                </div>
                            </div>
                            <div className={this.state.isProductionPadding ? 'pb-500 table-wrapper' : 'table-wrapper'}>
                                <table width={'100%'} cellSpacing={0}>
                                    <tr>
                                        <th className={'wt-150'}>Process</th>
                                        <th>Start Date</th>
                                        <th>Completion Date</th>
                                        <th>Production Status</th>
                                        <th className={'wt-100'}>Approval Required</th>
                                        <th>Upload Document</th>
                                        <th>Remark</th>
                                        <th className={'wt-80'}>Actions</th>
                                    </tr>
                                    {(partData.productionStatus || []).map((processData, pIndex) => {
                                        const isUnEditable = (processData.production_status_id && editId !=  processData.production_status_id)
                                    return(<tr>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                                <Input 
                                                className={'fs-14'}
                                                placeholder={'Enter Process'}
                                                value={processData.process}
                                                name={'process'}
                                                onChange={(e) => this.onChangeProcessInput(e, pIndex, partIndex)}
                                            />
                                            {/* <Select 
                                                styles={customStyles}
                                                menuPortalTarget={document.body}
                                                placeholder={'Select Process'}
                                                options={productionProcess || []}
                                                getOptionLabel={(option) => option.value}
                                                getOptionValue={(option) => option.id}
                                                value={processData.process && (productionProcess || []).find(el => el.value === processData.process)}
                                                onChange={(option) => this.onSelectProcessStatus(option, partIndex, pIndex, 'process', 'process_id')}
                                            /> */}
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <SingleDatePicker 
                                                className="pInput" 
                                                customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                inputIconPosition={'after'}
                                                displayFormat={"DD MMM YYYY"}
                                                isOutsideRange={(day) => {
                                                    if (partData.po_delivery_date) {
                                                        return day.isAfter(Moment(partData.po_delivery_date), 'day');
                                                    }
                                                    return true;
                                                }}
                                                hideKeyboardShortcutsPanel={true}
                                                placeholder={"dd/mm/yyyy"}
                                                numberOfMonths={1}
                                                date={processData.start_date ? Moment(processData.start_date) : ''} 
                                                onDateChange={(date) => this.onChangeProductionStatusDates(date, 'start_date', pIndex, partIndex)}
                                                focused={this.state[`focusedStartDate${partIndex}_${pIndex}`]}
                                                onFocusChange={({ focused }) => this.setState({ [`focusedStartDate${partIndex}_${pIndex}`]: focused, isProductionPadding: focused })}
                                            />
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <SingleDatePicker 
                                                className="pInput" 
                                                customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                inputIconPosition={'after'}
                                                displayFormat={"DD MMM YYYY"}
                                                isOutsideRange={(day) => {
                                                    if (partData.po_delivery_date) {
                                                        return day.isAfter(Moment(partData.po_delivery_date), 'day');
                                                    }
                                                    return true;
                                                }}
                                                hideKeyboardShortcutsPanel={true}
                                                placeholder={"dd/mm/yyyy"}
                                                numberOfMonths={1}
                                                date={processData.completion_date ? Moment(processData.completion_date) : ''} 
                                                onDateChange={(date) => this.onChangeProductionStatusDates(date, 'completion_date', pIndex, partIndex)}
                                                focused={this.state[`focusedCompletionDate${partIndex}_${pIndex}`]}
                                                onFocusChange={({ focused }) => this.setState({ [`focusedCompletionDate${partIndex}_${pIndex}`]: focused, isProductionPadding: focused })}
                                            />
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <Select 
                                                styles={customStyles}
                                                menuPortalTarget={document.body}
                                                placeholder={'Select Production Status'}
                                                options={productionStatus || []}
                                                getOptionLabel={(option) => option.value}
                                                getOptionValue={(option) => option.id}
                                                value={processData.production_status_name && (productionStatus || []).find(el => el.value === processData.production_status_name)}
                                                onChange={(option) => this.onSelectProcessStatus(option, partIndex, pIndex, 'production_status_name', 'production_status')}
                                            />
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <div className="switch" >
                                                <input type="checkbox" checked={processData.is_approval_required} id={`process_${partIndex}_${pIndex}`} onChange={(e) => this.onChangeProcessStatus(e, pIndex, partIndex)}/>
                                                <label htmlFor={`process_${partIndex}_${pIndex}`}></label>
                                            </div>
                                            {/* <div>{processData.approverMessage}</div> */}
                                        </td>
                                        <td className={'tdWidth'}>
                                            <Upload onChange={(file) => this.onUploadDocument(file, pIndex, 2, partIndex)} className={isUnEditable ? 'disabled' : ''}>
                                                <UploadIcon className={isUnEditable ? 'disabled wt-25 ht-25' : 'wt-25 ht-25 curP'}/>
                                            </Upload>
                                            {processData.uploaded_doc && <div className={'uploaded-data fs-14'}>
                                                    <a href={(processData.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15 curP"/>{(processData.uploaded_doc || {}).name}</a>
                                            </div>}
                                        </td>
                                        <td className={Cx('tdWidth',
                                            {'disabled' : isUnEditable })}>
                                            <Input 
                                                className={'fs-14'}
                                                placeholder={'Enter Remarks'}
                                                value={processData.remarks}
                                                name={'remarks'}
                                                onChange={(e) => this.onChangeProcessInput(e, pIndex, partIndex)}
                                            />
                                        </td>
                                        <td>
                                            {(![6, 99].includes(partData.status)) && <div className={'flex flex-between flex-middle'}>
                                                {(processData.production_status_id) ? 
                                                    <>
                                                        <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => this.onUpdateProductionStatus(processData, partData)}>Update</div>
                                                        <Edit className={'wt-20 ht-20 curP'} fill={'#627fe9'} onClick={() => this.onClickEdit(processData.production_status_id)}/>
                                                        <Delete className={'wt-15 ht-15 curP'} onClick={() => this.handleDeleteProductionStatus(processData)} />
                                                    </>
                                                    : 
                                                    <>
                                                    {partData && partData.po_part_id && <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => this.onSaveProductionStatus(processData, partData)}>Save</div>}
                                                    {(partData.productionStatus || []).length > 0 && 
                                                        <Delete className={'wt-15 ht-15 curP'} onClick={() => this.onDeleteProductionStatus(partIndex, pIndex)}/>
                                                    }
                                                    </>
                                                }
                                            </div>}
                                            {
                                                    processData.approverMessage && <div className={processData.is_accept == 1 ? 'success-color fs-14 mt-5' : 'error-color fs-14 mt-5'}>{processData.approverMessage}</div>
                                                }
                                                {processData.rejected_remarks && 
                                                    <div className={'mt-5'}>{processData.rejected_remarks}</div>
                                                }
                                        </td>
                                    </tr>)})}
                                </table>
                            </div>
                            {<div className={'flex flex-middle flex-between mt-10 mb-10 pv-5 ph-10'}>
                                <button className="divButton mr-10 curP" onClick={() => this.addNextProcess(partIndex)}>+ Update Next Process</button>
                                {(partData && partData.po_part_id && (partData.productionStatus || []).some(el => !el.production_status_id)) && <button className="divButton bgPrimary curP" onClick={() => this.onSaveProductionStatus('', partData)}>Submit</button>}
                            </div>}
                        </div>
                    </div>
                )})}
                {!data.po_id && <div className={'newOrder mr-10 mb-10'}>
                    <div className="flex flex-between">
                        <div className="subHeader">Add Part Details</div>
                        <div className="subHeader fs-14 curP" style={{'color' : '#597EF7'}} onClick={this.addPartDetails}>+ ADD Part Details</div>
                    </div>
                </div>}
                {<div className={'fRight mt-10 pb-20 mr-100'}>
                    {
                        (isEdit && data.po_id) ?  <button className="divButton bgPrimary curP" onClick={() => this.createOrDraftPO(2, false)}>Update Order</button> :
                        <>
                            <button className="divButton mr-10 curP" onClick={() => this.createOrDraftPO(1, true)}>Save Draft</button>
                            <button className="divButton bgPrimary curP" onClick={() => this.createOrDraftPO(2, false)}>Create Order</button>
                         </>
                    }   
                </div>}
            </div>
        )
    }
}

export default connect()(CreatePO);
